import React from 'react';
import Button from '../../../../../../../components/button';
import {AdvertisementType} from './SelectAdsBottomSheet';
import {useDeleteQRCode} from '../../../../../../../services/qrcode/useQRCode';

interface StoreOrderQRCode {
  setSelectBottomSheetOpen: React.Dispatch<React.SetStateAction<boolean>>;
  advertisementList: AdvertisementType[];
}

export default function StoreOrderQRCode({
  setSelectBottomSheetOpen,
  advertisementList,
}: StoreOrderQRCode) {
  // backend should return array of object that contain id , title ,link
  const {mutate: deleteQrCode} = useDeleteQRCode();

  const qrCodeData = advertisementList.filter(item => item?.link);

  const deleteHandler = (id: string) => {
    deleteQrCode({advertisementId: id});
  };
  return (
    <div className="flex flex-wrap w-full">
      <div className="flex flex-wrap gap-2 items-center text-sm">
        <span className="font-medium text-gray-900">اسکن کیو آر کد محصول</span>
        <span className="text-gray-600">(اختیاری)</span>
      </div>
      <p className="text-sm text-gray-600 text-wrap">
        با اسکن کیو آر کد محصولات، اصالت کالای فروخته شده را ثبت کنید.
      </p>

      <div className="flex flex-wrap justify-start items-center w-full">
        {qrCodeData.map(item => (
          <div className="flex relative flex-col justify-center items-center py-4 w-1/4 text-gray-600 shrink-0">
            <i className="ml-1 text-3xl icon-qr-code" />
            <span className="max-w-full text-xs text-center truncate whitespace-pre break-words">
              {item?.title_snapshot}
            </span>
            <span
              onClick={() => deleteHandler(item.advertisement)}
              className="absolute top-0 left-4 p-1 w-4 h-4 text-red-400 rounded-full"
            >
              <i className="text-base text-red-600 icon-nameClose-remove" />
            </span>
          </div>
        ))}

        <div className="flex justify-end w-full">
          <Button
            onClick={() => setSelectBottomSheetOpen(true)}
            className="!min-h-9 max-w-20"
            size="small"
            variant="outline"
            color="green"
          >
            <i className="ml-1 text-md icon-qr-code" />
            اسکن
          </Button>
        </div>
      </div>
    </div>
  );
}
